export class Interaction {
    public static readonly MinTextSearchLength = 3;
    public static readonly MinNumberSearchLength = 2;
    public static readonly MaxGlobalSearchLength = 30;
    public static readonly SearchDebounceTimeMs = 500;
}
